import { Modal, Button } from 'antd';
import { t } from 'i18next';
import { useEffect } from 'react';
import IconFail from '../../../assets/Images/icons/icon-fail';

const ModalFail = ({
    open,
    title = t('common.Fail'),
    text = 'Failed to submit data.',
    handelClose,
    icon = <IconFail />,
}) => {
    useEffect(() => {
        // setTimeout(() => handelClose(), 2000);
    }, [open]);
    return (
        <Modal
            width={450}
            className="_modal"
            footer={false}
            open={open}
            closable={false}
            onCancel={handelClose}
        >
            <div className="flex flex-col space-y-4 justify-center items-center py-6">
                {icon}
                <div className="text-2xl font-semibold">{title}</div>
                <p className="text-center">{text}</p>
                <div className="text-center">
                    <Button
                        style={{ width: '135px', marginTop: '30px' }}
                        type="primary"
                        onClick={handelClose}
                        size={'large'}
                    >
                        {t('common.Close')}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};
export default ModalFail;
